// extracted by mini-css-extract-plugin
module.exports = {"container":"_3EiT0","innerContainer":"_3mawK","voteIcon":"_3JRjJ","voteIconInactive":"_1CwQ4","voteCount":"XCPLh"};